import React from 'react';
import _ from 'lodash';
import {Grid} from 'semantic-ui-react';
import {
  TextBoxField,
  InlineSelect,
  RadioField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {RADIO_OPTIONS} from 'go/components/dynamic/modules/projectSiteInventory/constants';
import {
  isLocationInfrastructureInventoryType,
  getOptionText,
} from 'go/components/dynamic/modules/projectSiteInventory/utils';

const defaultSelected = {
  text: 'Select',
  value: '',
  key: 'select-default',
};

export class OwnerInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {options, locationType} = this.props;
    const isInfrastructure = isLocationInfrastructureInventoryType(locationType);

    if (!this.props.inventoryItem.owner) return <p>No data available</p>;
    const {
      owner,
      ownerType,
      coownerType,
      ownerSameAddressAsProperty,
      ownerHasCoowner,
      coownerSameAddressAsProperty,
      coownerSameAddressAsOwner,
    } = this.props.inventoryItem;
    const {displayType} = this.props;
    return (
      <div id="owner-information">
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="owner-type">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">Owner type</p>
                    {getOptionText(_.get(options, 'propertyOwnerTypes', []), ownerType)}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    {options && (
                      <InlineSelect
                        options={[
                          defaultSelected,
                          ..._.sortBy(options.propertyOwnerTypes, 'displayOrder'),
                        ]}
                        id="location-owner-type"
                        label="Owner type"
                        title="ownerType"
                        name="ownerType"
                        value={ownerType}
                        handleChange={this.props.handleChange}
                        handleBlur={this.props.handleBlur}
                        displayError={this.props.displayError('ownerType')}
                        errorMessages={this.props.getErrorMessage(
                          'ownerType',
                          'Owner type'
                        )}
                      />
                    )}
                  </div>
                )}
              </div>
            </Grid.Column>
            <Grid.Column mobile={16} computer={8}>
              <div id="coowner-type">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">Company name</p>
                    {owner.companyName}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    {options && (
                      <TextBoxField
                        id="co-owner-company-name-control"
                        label="Company name"
                        title="Required: Company name"
                        name="owner.companyName"
                        value={owner.companyName}
                        handleChange={this.props.handleChange}
                        handleBlur={this.props.handleBlur}
                        displayError={this.props.displayError('owner.companyName')}
                        errorMessages={this.props.getErrorMessage(
                          'owner.companyName',
                          'Company name'
                        )}
                      />
                    )}
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="owner-first-name">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">First name</p>
                    {owner.firstName}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <TextBoxField
                      maxLength={50}
                      id="owner-first-name-control"
                      label="First name"
                      title="Required: First name"
                      name="owner.firstName"
                      value={owner.firstName}
                      handleChange={this.props.handleChange}
                      handleBlur={this.props.handleBlur}
                      displayError={this.props.displayError('owner.firstName')}
                      errorMessages={this.props.getErrorMessage(
                        'owner.firstName',
                        'First name'
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
            <Grid.Column mobile={16} computer={8}>
              <div id="owner-middle-name">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">
                      Middle name <span>(Optional)</span>
                    </p>
                    {owner.middleName}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <TextBoxField
                      maxLength={25}
                      id="owner-middle-name-control"
                      label="Middle name"
                      optional={true}
                      title="Optional: Middle name"
                      name="owner.middleName"
                      value={owner.middleName}
                      handleChange={this.props.handleChange}
                      handleBlur={this.props.handleBlur}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="owner-last-name">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">Last name</p>
                    {owner.lastName}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <TextBoxField
                      maxLength={50}
                      id="owner-last-name-control"
                      label="Last name"
                      title="Required: Last name"
                      name="owner.lastName"
                      value={owner.lastName}
                      handleChange={this.props.handleChange}
                      handleBlur={this.props.handleBlur}
                      displayError={this.props.displayError('owner.lastName')}
                      errorMessages={this.props.getErrorMessage(
                        'owner.lastName',
                        'Last name'
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
            <Grid.Column mobile={16} computer={8}>
              <div id="owner-suffix">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">
                      Suffix <span>(Optional)</span>
                    </p>
                    {getOptionText(_.get(options, 'suffix', []), _.get(owner, 'suffix'))}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    {options && (
                      <InlineSelect
                        options={[defaultSelected, ...options.suffix]}
                        id="owner-suffix-control"
                        value={_.get(owner, 'suffix')}
                        label="Suffix"
                        title="Optional: Suffix"
                        optional={true}
                        name="owner.suffix"
                        handleChange={this.props.handleChange}
                        handleBlur={this.props.handleBlur}
                        displayError={this.props.displayError('owner.suffix')}
                        errorMessages={this.props.getErrorMessage(
                          'owner.suffix',
                          'Suffix'
                        )}
                      />
                    )}
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="owner-primary-contact-phone">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">Primary contact phone number</p>
                    {owner.primaryPhone}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <TextBoxField
                      id="owner-primary-contact-phone-control"
                      label="Primary contact phone number"
                      title="Required: Primary contact phone number"
                      name="owner.primaryPhone"
                      value={owner.primaryPhone}
                      handleChange={this.props.handleChangePhoneNumber}
                      handleBlur={this.props.handleBlur}
                      displayError={this.props.displayError('owner.primaryPhone')}
                      errorMessages={this.props.getErrorMessage(
                        'owner.primaryPhone',
                        'Primary phone'
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="owner-secondary-contact-phone">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">
                      Secondary contact phone number <span>(Optional)</span>
                    </p>
                    {owner.secondaryPhone}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <TextBoxField
                      id="owner-secondary-contact-phone-control"
                      label="Secondary contact phone number"
                      optional={true}
                      title="Optional: Secondary contact phone number"
                      name="owner.secondaryPhone"
                      value={owner.secondaryPhone}
                      handleChange={this.props.handleChangePhoneNumber}
                      handleBlur={this.props.handleBlur}
                      displayError={this.props.displayError('owner.secondaryPhone')}
                      errorMessages={this.props.getErrorMessage(
                        'owner.secondaryPhone',
                        'Secondary phone'
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="owner-email">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">
                      Email <span>(Optional)</span>
                    </p>
                    {owner.email}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <TextBoxField
                      id="owner-email-control"
                      label="Email"
                      optional={true}
                      title="Optional: Email"
                      name="owner.email"
                      value={owner.email}
                      handleChange={this.props.handleChange}
                      handleBlur={this.props.handleBlur}
                      displayError={this.props.displayError('owner.email')}
                      errorMessages={this.props.getErrorMessage('owner.email', 'Email')}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="owner-mailing-address-same-as-property-address">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">
                      Is the owner's mailing address the same as the location address?
                    </p>
                    {ownerSameAddressAsProperty === true ? 'Yes' : 'No'}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <RadioField
                      id="owner-mailing-address-same-as-property-address-control"
                      label="Is the owner's mailing address the same as the location address?"
                      title="Required: Is the owner's mailing address the same as the location address?"
                      name="ownerSameAddressAsProperty"
                      value={ownerSameAddressAsProperty}
                      handleChange={this.props.handleChangeBoolean}
                      handleBlur={this.props.handleBlur}
                      options={RADIO_OPTIONS}
                      displayError={this.props.displayError('ownerSameAddressAsProperty')}
                      errorMessages={this.props.getErrorMessage(
                        'ownerSameAddressAsProperty',
                        "Is the owner's mailing address the same as the location address?"
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          {ownerSameAddressAsProperty === false && (
            <React.Fragment>
              <span className="label">Enter Owner's mailing address</span>
              <br />
              <Grid.Row>
                <Grid.Column mobile={16} computer={8}>
                  <div id="owner-addres-1">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">Address 1</p>
                        {owner.address.addr1}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          id="owner-addres-1-control"
                          label="Address 1"
                          title="Required: Address 1"
                          name="owner.address.addr1"
                          value={owner.address.addr1}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError('owner.address.addr1')}
                          errorMessages={this.props.getErrorMessage(
                            'owner.address.addr1',
                            'Address 1'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} computer={8}>
                  <div id="owner-addres-2">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">
                          Address 2 <span>(Optional)</span>
                        </p>
                        {owner.address.addr2}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          id="owner-addres-2-control"
                          label="Address 2"
                          optional={true}
                          title="Optional: Address 2"
                          name="owner.address.addr2"
                          value={owner.address.addr2}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} computer={8}>
                  <div id="owner-city">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">City</p>
                        {owner.address.city}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          id="owner-city-control"
                          label="City"
                          title="Required: City"
                          name="owner.address.city"
                          value={owner.address.city}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError('owner.address.city')}
                          errorMessages={this.props.getErrorMessage(
                            'owner.address.city',
                            'City'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
                <Grid.Column mobile={16} computer={8}>
                  <div id="owner-county">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">County</p>
                        {owner.address.county}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          id="owner-county-control"
                          label="County"
                          title="Required: County"
                          name="owner.address.county"
                          value={owner.address.county}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError('owner.address.county')}
                          errorMessages={this.props.getErrorMessage(
                            'owner.address.county',
                            'County'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} computer={8}>
                  <div id="owner-state">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">State</p>
                        {getOptionText(
                          _.get(options, 'usStates', []),
                          _.get(owner, 'address.state', '')
                        )}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        {options && (
                          <InlineSelect
                            id="owner-state-control"
                            label="State"
                            options={[defaultSelected, ...options.usStates]}
                            name="owner.address.state"
                            title="Required: State"
                            value={owner.address.state}
                            handleChange={this.props.handleChange}
                            handleBlur={this.props.handleBlur}
                            displayError={this.props.displayError('owner.address.state')}
                            errorMessages={this.props.getErrorMessage(
                              'owner.address.state',
                              'State'
                            )}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </Grid.Column>
                <Grid.Column mobile={16} computer={8}>
                  <div id="owner-zip">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">Zip code</p>
                        {owner.address.zip}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          maxLength={5}
                          id="owner-zip-control"
                          label="Zip code"
                          title="Required: Zip code"
                          name="owner.address.zip"
                          value={owner.address.zip}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError('owner.address.zip')}
                          errorMessages={this.props.getErrorMessage(
                            'owner.address.zip',
                            'Zip'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </React.Fragment>
          )}
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="property-has-co-owner">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label bold">
                      Does the structure have other co-owners or holders of recorded
                      interest?
                    </p>
                    {ownerHasCoowner === true ? 'Yes' : 'No'}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <RadioField
                      id="property-has-co-owner-control"
                      label="Does the structure have other co-owners or holders of
                      recorded interest?"
                      title="Required: Property has co-owner?"
                      name="ownerHasCoowner"
                      value={ownerHasCoowner}
                      handleChange={this.props.handleChangeBoolean}
                      handleBlur={this.props.handleBlur}
                      options={RADIO_OPTIONS}
                      displayError={this.props.displayError('ownerHasCoowner')}
                      errorMessages={this.props.getErrorMessage(
                        'ownerHasCoowner',
                        'Does the structure have other co-owners or holders of recorded interest?'
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          {ownerHasCoowner === true && (
            <React.Fragment>
              <Grid.Row>
                <Grid.Column mobile={16} computer={8}>
                  <div id="coowner-type">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">Co-owner type</p>
                        {getOptionText(
                          _.get(options, 'propertyOwnerTypes', []),
                          coownerType
                        )}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        {options && (
                          <InlineSelect
                            options={[
                              defaultSelected,
                              ..._.sortBy(options.propertyOwnerTypes, 'displayOrder'),
                            ]}
                            id="location-coowner-type"
                            label="Co-owner type"
                            title="coownerType"
                            name="coownerType"
                            value={coownerType}
                            handleChange={this.props.handleChange}
                            handleBlur={this.props.handleBlur}
                            displayError={this.props.displayError('coownerType')}
                            errorMessages={this.props.getErrorMessage(
                              'coownerType',
                              'Co-owner Type'
                            )}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </Grid.Column>
                <Grid.Column mobile={16} computer={8}>
                  <div id="coowner-type">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">Company name</p>
                        {owner.coowner.companyName}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        {options && (
                          <TextBoxField
                            id="co-owner-company-name-control"
                            label="Company name"
                            title="Required: Company name"
                            name="owner.coowner.companyName"
                            value={owner.coowner.companyName}
                            handleChange={this.props.handleChange}
                            handleBlur={this.props.handleBlur}
                            displayError={this.props.displayError(
                              'owner.coowner.companyName'
                            )}
                            errorMessages={this.props.getErrorMessage(
                              'owner.coowner.companyName',
                              'Company name'
                            )}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} computer={8}>
                  <div id="co-owner-first-name">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">First name</p>
                        {owner.coowner.firstName}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          maxLength={50}
                          id="co-owner-first-name-control"
                          label="First name"
                          title="Required: First name"
                          name="owner.coowner.firstName"
                          value={owner.coowner.firstName}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError(
                            'owner.coowner.firstName'
                          )}
                          errorMessages={this.props.getErrorMessage(
                            'owner.coowner.firstName',
                            'First name'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
                <Grid.Column mobile={16} computer={8}>
                  <div id="co-owner-middle-name">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">
                          Middle name <span>(Optional)</span>
                        </p>
                        {owner.coowner.middleName}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          maxLength={25}
                          id="co-owner-middle-name-control"
                          label="Middle name"
                          optional={true}
                          title="Optional: Middle name"
                          name="owner.coowner.middleName"
                          value={owner.coowner.middleName}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} computer={8}>
                  <div id="co-owner-last-name">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">Last name</p>
                        {owner.coowner.lastName}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          maxLength={50}
                          id="co-owner-last-name-control"
                          label="Last name"
                          title="Required: Last name"
                          name="owner.coowner.lastName"
                          value={owner.coowner.lastName}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError('owner.coowner.lastName')}
                          errorMessages={this.props.getErrorMessage(
                            'owner.coowner.lastName',
                            'Last name'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
                <Grid.Column mobile={16} computer={8}>
                  <div id="co-owner-suffix">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">
                          Suffix <span>(Optional)</span>
                        </p>
                        {getOptionText(
                          _.get(options, 'suffix', []),
                          _.get(owner, 'coowner.suffix', '')
                        )}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        {options && (
                          <InlineSelect
                            options={[defaultSelected, ...options.suffix]}
                            id="co-owner-suffix-control"
                            value={_.get(owner, 'coowner.suffix', '')}
                            label="Suffix"
                            title="Optional: Suffix"
                            optional={true}
                            name="owner.coowner.suffix"
                            handleChange={this.props.handleChange}
                            handleBlur={this.props.handleBlur}
                            displayError={this.props.displayError('owner.coowner.suffix')}
                            errorMessages={this.props.getErrorMessage(
                              'owner.coowner.suffix',
                              'Suffix'
                            )}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} computer={8}>
                  <div id="co-owner-primary-contact-phone-number">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">Primary contact phone number</p>
                        {owner.coowner.primaryPhone}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          id="co-owner-primary-contact-phone-number-control"
                          label="Primary contact phone number"
                          title="Required: Primary contact phone number"
                          name="owner.coowner.primaryPhone"
                          value={owner.coowner.primaryPhone}
                          handleChange={this.props.handleChangePhoneNumber}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError(
                            'owner.coowner.primaryPhone'
                          )}
                          errorMessages={this.props.getErrorMessage(
                            'owner.coowner.primaryPhone',
                            'Primary phone'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} computer={8}>
                  <div id="co-owner-secondary-contact-phone-number">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">
                          Secondary contact phone number <span>(Optional)</span>
                        </p>
                        {owner.coowner.secondaryPhone}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          id="co-owner-secondary-contact-phone-number-control"
                          label="Secondary contact phone number"
                          optional={true}
                          title="Optional: Secondary contact phone number"
                          name="owner.coowner.secondaryPhone"
                          value={owner.coowner.secondaryPhone}
                          handleChange={this.props.handleChangePhoneNumber}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError(
                            'owner.coowner.secondaryPhone'
                          )}
                          errorMessages={this.props.getErrorMessage(
                            'owner.coowner.secondaryPhone',
                            'Secondary contact phone number'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} computer={8}>
                  <div id="co-owner-email">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">
                          Email <span>(Optional)</span>
                        </p>
                        {owner.coowner.email}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          id="co-owner-email-control"
                          label="Email"
                          optional={true}
                          title="Optional: Email"
                          name="owner.coowner.email"
                          value={owner.coowner.email}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError('owner.coowner.email')}
                          errorMessages={this.props.getErrorMessage(
                            'owner.coowner.email',
                            'Email'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} computer={8}>
                  <div id="owner-coowner-same-mailing-address">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">
                          Is the co-owner's mailing address the same as the owner's
                          mailing address?
                        </p>
                        {coownerSameAddressAsOwner === true ? 'Yes' : 'No'}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <RadioField
                          id="owner-coowner-same-mailing-address-control"
                          label="Is the co-owner's mailing address the same as the owner's mailing address?"
                          title="Required: Is the co-owner's mailing address the same as the owner's mailing address?"
                          name="coownerSameAddressAsOwner"
                          value={coownerSameAddressAsOwner}
                          handleChange={this.props.handleChangeBoolean}
                          handleBlur={this.props.handleBlur}
                          options={RADIO_OPTIONS}
                          displayError={this.props.displayError(
                            'coownerSameAddressAsOwner'
                          )}
                          errorMessages={this.props.getErrorMessage(
                            'coownerSameAddressAsOwner',
                            "Is the co-owner's mailing address the same as the owner's mailing address?"
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              {coownerSameAddressAsOwner === false && (
                <React.Fragment>
                  <Grid.Row>
                    <Grid.Column mobile={16} computer={8}>
                      <div id="coowner-mailing-address-same-as-property-address">
                        {displayType === 'view' ? (
                          <React.Fragment>
                            <p className="label bold">
                              Is the co-owner's mailing address the same as the location
                              address?
                            </p>
                            {coownerSameAddressAsProperty === true ? 'Yes' : 'No'}
                          </React.Fragment>
                        ) : (
                          <div className="util--full-width ui form">
                            <RadioField
                              id="coowner-mailing-address-same-as-property-address-control"
                              label="Is the co-owner's mailing address the same as the location address?"
                              title="Required: Is the co-owner's mailing address the same as the location address?"
                              name="coownerSameAddressAsProperty"
                              value={coownerSameAddressAsProperty}
                              handleChange={this.props.handleChangeBoolean}
                              handleBlur={this.props.handleBlur}
                              options={RADIO_OPTIONS}
                              displayError={this.props.displayError(
                                'coownerSameAddressAsProperty'
                              )}
                              errorMessages={this.props.getErrorMessage(
                                'coownerSameAddressAsProperty',
                                "Is the co-owner's mailing address the same as the location address?"
                              )}
                            />
                          </div>
                        )}
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                  {!coownerSameAddressAsOwner && !coownerSameAddressAsProperty && (
                    <React.Fragment>
                      <span className="label">Enter co-owner's mailing address</span>
                      <br />
                      <Grid.Row>
                        <Grid.Column mobile={16} computer={8}>
                          <div id="co-owner-address-1">
                            {displayType === 'view' ? (
                              <React.Fragment>
                                <p className="label">Address 1</p>
                                {owner.coowner.address.addr1}
                              </React.Fragment>
                            ) : (
                              <div className="util--full-width ui form">
                                <TextBoxField
                                  id="co-owner-address-1-control"
                                  label="Address 1"
                                  title="Required: Address 1"
                                  name="owner.coowner.address.addr1"
                                  value={owner.coowner.address.addr1}
                                  handleChange={this.props.handleChange}
                                  handleBlur={this.props.handleBlur}
                                  displayError={this.props.displayError(
                                    'owner.coowner.address.addr1'
                                  )}
                                  errorMessages={this.props.getErrorMessage(
                                    'owner.coowner.address.addr1',
                                    'Address 1'
                                  )}
                                />
                              </div>
                            )}
                          </div>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column mobile={16} computer={8}>
                          <div id="co-owner-address-2">
                            {displayType === 'view' ? (
                              <React.Fragment>
                                <p className="label">
                                  Address 2 <span>(Optional)</span>
                                </p>
                                {owner.coowner.address.addr2}
                              </React.Fragment>
                            ) : (
                              <div className="util--full-width ui form">
                                <TextBoxField
                                  id="co-owner-address-2-control"
                                  label="Address 2"
                                  optional={true}
                                  title="Optional: Address 2"
                                  name="owner.coowner.address.addr2"
                                  value={owner.coowner.address.addr2}
                                  handleChange={this.props.handleChange}
                                  handleBlur={this.props.handleBlur}
                                />
                              </div>
                            )}
                          </div>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column mobile={16} computer={8}>
                          <div id="co-owner-city">
                            {displayType === 'view' ? (
                              <React.Fragment>
                                <p className="label">City</p>
                                {owner.coowner.address.city}
                              </React.Fragment>
                            ) : (
                              <div className="util--full-width ui form">
                                <TextBoxField
                                  id="co-owner-city-control"
                                  label="City"
                                  title="Required: City"
                                  name="owner.coowner.address.city"
                                  value={owner.coowner.address.city}
                                  handleChange={this.props.handleChange}
                                  handleBlur={this.props.handleBlur}
                                  displayError={this.props.displayError(
                                    'owner.coowner.address.city'
                                  )}
                                  errorMessages={this.props.getErrorMessage(
                                    'owner.coowner.address.city',
                                    'City'
                                  )}
                                />
                              </div>
                            )}
                          </div>
                        </Grid.Column>
                        <Grid.Column mobile={16} computer={8}>
                          <div id="co-owner-county">
                            {displayType === 'view' ? (
                              <React.Fragment>
                                <p className="label">County</p>
                                {owner.coowner.address.county}
                              </React.Fragment>
                            ) : (
                              <div className="util--full-width ui form">
                                <TextBoxField
                                  id="co-owner-county-control"
                                  label="County"
                                  title="Required: County"
                                  name="owner.coowner.address.county"
                                  value={owner.coowner.address.county}
                                  handleChange={this.props.handleChange}
                                  handleBlur={this.props.handleBlur}
                                  displayError={this.props.displayError(
                                    'owner.coowner.address.county'
                                  )}
                                  errorMessages={this.props.getErrorMessage(
                                    'owner.coowner.address.county',
                                    'County'
                                  )}
                                />
                              </div>
                            )}
                          </div>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column mobile={16} computer={8}>
                          <div id="co-owner-state">
                            {displayType === 'view' ? (
                              <React.Fragment>
                                <p className="label">State</p>
                                {getOptionText(
                                  _.get(options, 'usStates', []),
                                  _.get(owner, 'coowner.address.state', '')
                                )}
                              </React.Fragment>
                            ) : (
                              <div className="util--full-width ui form">
                                {options && (
                                  <InlineSelect
                                    options={[defaultSelected, ...options.usStates]}
                                    id="location-state-control"
                                    label="State"
                                    title="owner.coowner.address.state"
                                    name="owner.coowner.address.state"
                                    value={owner.coowner.address.state}
                                    handleChange={this.props.handleChange}
                                    handleBlur={this.props.handleBlur}
                                    displayError={this.props.displayError(
                                      'owner.coowner.address.state'
                                    )}
                                    errorMessages={this.props.getErrorMessage(
                                      'owner.coowner.address.state',
                                      'Coowner State'
                                    )}
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </Grid.Column>
                        <Grid.Column mobile={16} computer={8}>
                          <div id="co-owner-zip">
                            {displayType === 'view' ? (
                              <React.Fragment>
                                <p className="label">Zip code</p>
                                {owner.coowner.address.zip}
                              </React.Fragment>
                            ) : (
                              <div className="util--full-width ui form">
                                <TextBoxField
                                  maxLength={5}
                                  id="co-owner-address-zip-control"
                                  label="Zip code"
                                  title="Required: Zip code"
                                  name="owner.coowner.address.zip"
                                  value={owner.coowner.address.zip}
                                  handleChange={this.props.handleChange}
                                  handleBlur={this.props.handleBlur}
                                  displayError={this.props.displayError(
                                    'owner.coowner.address.zip'
                                  )}
                                  errorMessages={this.props.getErrorMessage(
                                    'owner.coowner.address.zip',
                                    'Zip'
                                  )}
                                />
                              </div>
                            )}
                          </div>
                        </Grid.Column>
                      </Grid.Row>
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </Grid>
      </div>
    );
  }
}

export default OwnerInformation;
